import * as Fmt_format_of_request_bs$SolvuuApi0 from "./fmt_format_of_request_bs.bs.js";
var Json =
/* alias */
0;
var json_of_fmt = Fmt_format_of_request_bs$SolvuuApi0.write_fmt;
var json_of_info = Fmt_format_of_request_bs$SolvuuApi0.write_info;
var fmt_of_json = Fmt_format_of_request_bs$SolvuuApi0.read_fmt;
var info_of_json = Fmt_format_of_request_bs$SolvuuApi0.read_info;
export { Json, json_of_fmt, json_of_info, fmt_of_json, info_of_json };
/* Fmt_format_of_request_bs-SolvuuApi0 Not a pure module */